<template>
  <v-snackbar v-model="messageOn" :color="message.color" right top>
    {{ message.message }}
    <v-btn dark text @click="setMessage({ message: null })">Cerrar</v-btn>
  </v-snackbar>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "Toast",

  computed: {
    messageOn: {
      get() {
        return !!this.message.message;
      },
      set(val) {}
    },
    ...mapGetters({
      message: "getMessage"
    })
  },

  methods: { ...mapMutations(["setMessage"]) }
};
</script>
